/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PaymentInactiveRouteImport } from './routes/payment-inactive'
import { Route as OrgMismatchRouteImport } from './routes/org-mismatch'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConnectorErrorRouteImport } from './routes/connector-error'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as UserVerifyEmailRouteImport } from './routes/user/verify-email'
import { Route as UserVerifyRouteImport } from './routes/user/verify'
import { Route as UserSetPasswordRouteImport } from './routes/user/set-password'
import { Route as UserResendVerificationRouteImport } from './routes/user/resend-verification'
import { Route as UserPasswordResetRouteImport } from './routes/user/password-reset'
import { Route as AuthOrgSlugRouteRouteImport } from './routes/_auth/$orgSlug/route'
import { Route as AuthOrgSlugIndexRouteImport } from './routes/_auth/$orgSlug/index'
import { Route as AuthOrgSlugProjectIdRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/route'
import { Route as AuthOrgSlugUsersIndexRouteImport } from './routes/_auth/$orgSlug/users/index'
import { Route as AuthOrgSlugProfileIndexRouteImport } from './routes/_auth/$orgSlug/profile/index'
import { Route as AuthOrgSlugAccountIndexRouteImport } from './routes/_auth/$orgSlug/account/index'
import { Route as AuthOrgSlugProjectIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/index'
import { Route as AuthOrgSlugProjectIdSearchAgentRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/search-agent/route'
import { Route as AuthOrgSlugProjectIdMarketingAgentRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/marketing-agent/route'
import { Route as AuthOrgSlugContentTextIndexRouteImport } from './routes/_auth/$orgSlug/content/text/index'
import { Route as AuthOrgSlugContentFileIndexRouteImport } from './routes/_auth/$orgSlug/content/file/index'
import { Route as AuthOrgSlugContentConnectorIndexRouteImport } from './routes/_auth/$orgSlug/content/connector/index'
import { Route as AuthOrgSlugProjectIdSearchAgentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/search-agent/index'
import { Route as AuthOrgSlugProjectIdMarketingAgentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/marketing-agent/index'
import { Route as AuthOrgSlugProjectIdContentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/index'
import { Route as AuthOrgSlugProjectIdSearchAgentThreadIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/search-agent/$threadId/index'
import { Route as AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/marketing-agent/$threadId/index'
import { Route as AuthOrgSlugProjectIdContentTextIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/text/index'
import { Route as AuthOrgSlugProjectIdContentFileIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/file/index'
import { Route as AuthOrgSlugProjectIdContentConnectorIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/connector/index'

const PaymentInactiveRoute = PaymentInactiveRouteImport.update({
  id: '/payment-inactive',
  path: '/payment-inactive',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgMismatchRoute = OrgMismatchRouteImport.update({
  id: '/org-mismatch',
  path: '/org-mismatch',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorErrorRoute = ConnectorErrorRouteImport.update({
  id: '/connector-error',
  path: '/connector-error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const UserVerifyEmailRoute = UserVerifyEmailRouteImport.update({
  id: '/user/verify-email',
  path: '/user/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UserVerifyRoute = UserVerifyRouteImport.update({
  id: '/user/verify',
  path: '/user/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const UserSetPasswordRoute = UserSetPasswordRouteImport.update({
  id: '/user/set-password',
  path: '/user/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const UserResendVerificationRoute = UserResendVerificationRouteImport.update({
  id: '/user/resend-verification',
  path: '/user/resend-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const UserPasswordResetRoute = UserPasswordResetRouteImport.update({
  id: '/user/password-reset',
  path: '/user/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOrgSlugRouteRoute = AuthOrgSlugRouteRouteImport.update({
  id: '/$orgSlug',
  path: '/$orgSlug',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrgSlugIndexRoute = AuthOrgSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugProjectIdRouteRoute =
  AuthOrgSlugProjectIdRouteRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthOrgSlugUsersIndexRoute = AuthOrgSlugUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugProfileIndexRoute = AuthOrgSlugProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugAccountIndexRoute = AuthOrgSlugAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugProjectIdIndexRoute =
  AuthOrgSlugProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdSearchAgentRouteRoute =
  AuthOrgSlugProjectIdSearchAgentRouteRouteImport.update({
    id: '/search-agent',
    path: '/search-agent',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdMarketingAgentRouteRoute =
  AuthOrgSlugProjectIdMarketingAgentRouteRouteImport.update({
    id: '/marketing-agent',
    path: '/marketing-agent',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugContentTextIndexRoute =
  AuthOrgSlugContentTextIndexRouteImport.update({
    id: '/content/text/',
    path: '/content/text/',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthOrgSlugContentFileIndexRoute =
  AuthOrgSlugContentFileIndexRouteImport.update({
    id: '/content/file/',
    path: '/content/file/',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthOrgSlugContentConnectorIndexRoute =
  AuthOrgSlugContentConnectorIndexRouteImport.update({
    id: '/content/connector/',
    path: '/content/connector/',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthOrgSlugProjectIdSearchAgentIndexRoute =
  AuthOrgSlugProjectIdSearchAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdSearchAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdMarketingAgentIndexRoute =
  AuthOrgSlugProjectIdMarketingAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdMarketingAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentIndexRoute =
  AuthOrgSlugProjectIdContentIndexRouteImport.update({
    id: '/content/',
    path: '/content/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute =
  AuthOrgSlugProjectIdSearchAgentThreadIdIndexRouteImport.update({
    id: '/$threadId/',
    path: '/$threadId/',
    getParentRoute: () => AuthOrgSlugProjectIdSearchAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute =
  AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRouteImport.update({
    id: '/$threadId/',
    path: '/$threadId/',
    getParentRoute: () => AuthOrgSlugProjectIdMarketingAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentTextIndexRoute =
  AuthOrgSlugProjectIdContentTextIndexRouteImport.update({
    id: '/content/text/',
    path: '/content/text/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentFileIndexRoute =
  AuthOrgSlugProjectIdContentFileIndexRouteImport.update({
    id: '/content/file/',
    path: '/content/file/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentConnectorIndexRoute =
  AuthOrgSlugProjectIdContentConnectorIndexRouteImport.update({
    id: '/content/connector/',
    path: '/content/connector/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/connector-error': typeof ConnectorErrorRoute
  '/login': typeof LoginRoute
  '/org-mismatch': typeof OrgMismatchRoute
  '/payment-inactive': typeof PaymentInactiveRoute
  '/$orgSlug': typeof AuthOrgSlugRouteRouteWithChildren
  '/user/password-reset': typeof UserPasswordResetRoute
  '/user/resend-verification': typeof UserResendVerificationRoute
  '/user/set-password': typeof UserSetPasswordRoute
  '/user/verify': typeof UserVerifyRoute
  '/user/verify-email': typeof UserVerifyEmailRoute
  '/$orgSlug/$projectId': typeof AuthOrgSlugProjectIdRouteRouteWithChildren
  '/$orgSlug/': typeof AuthOrgSlugIndexRoute
  '/$orgSlug/$projectId/marketing-agent': typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren
  '/$orgSlug/$projectId/search-agent': typeof AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren
  '/$orgSlug/$projectId/': typeof AuthOrgSlugProjectIdIndexRoute
  '/$orgSlug/account/': typeof AuthOrgSlugAccountIndexRoute
  '/$orgSlug/profile/': typeof AuthOrgSlugProfileIndexRoute
  '/$orgSlug/users/': typeof AuthOrgSlugUsersIndexRoute
  '/$orgSlug/$projectId/content/': typeof AuthOrgSlugProjectIdContentIndexRoute
  '/$orgSlug/$projectId/marketing-agent/': typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  '/$orgSlug/$projectId/search-agent/': typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  '/$orgSlug/content/connector/': typeof AuthOrgSlugContentConnectorIndexRoute
  '/$orgSlug/content/file/': typeof AuthOrgSlugContentFileIndexRoute
  '/$orgSlug/content/text/': typeof AuthOrgSlugContentTextIndexRoute
  '/$orgSlug/$projectId/content/connector/': typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  '/$orgSlug/$projectId/content/file/': typeof AuthOrgSlugProjectIdContentFileIndexRoute
  '/$orgSlug/$projectId/content/text/': typeof AuthOrgSlugProjectIdContentTextIndexRoute
  '/$orgSlug/$projectId/marketing-agent/$threadId/': typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
  '/$orgSlug/$projectId/search-agent/$threadId/': typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}
export interface FileRoutesByTo {
  '/connector-error': typeof ConnectorErrorRoute
  '/login': typeof LoginRoute
  '/org-mismatch': typeof OrgMismatchRoute
  '/payment-inactive': typeof PaymentInactiveRoute
  '/user/password-reset': typeof UserPasswordResetRoute
  '/user/resend-verification': typeof UserResendVerificationRoute
  '/user/set-password': typeof UserSetPasswordRoute
  '/user/verify': typeof UserVerifyRoute
  '/user/verify-email': typeof UserVerifyEmailRoute
  '/': typeof AuthIndexRoute
  '/$orgSlug': typeof AuthOrgSlugIndexRoute
  '/$orgSlug/$projectId': typeof AuthOrgSlugProjectIdIndexRoute
  '/$orgSlug/account': typeof AuthOrgSlugAccountIndexRoute
  '/$orgSlug/profile': typeof AuthOrgSlugProfileIndexRoute
  '/$orgSlug/users': typeof AuthOrgSlugUsersIndexRoute
  '/$orgSlug/$projectId/content': typeof AuthOrgSlugProjectIdContentIndexRoute
  '/$orgSlug/$projectId/marketing-agent': typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  '/$orgSlug/$projectId/search-agent': typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  '/$orgSlug/content/connector': typeof AuthOrgSlugContentConnectorIndexRoute
  '/$orgSlug/content/file': typeof AuthOrgSlugContentFileIndexRoute
  '/$orgSlug/content/text': typeof AuthOrgSlugContentTextIndexRoute
  '/$orgSlug/$projectId/content/connector': typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  '/$orgSlug/$projectId/content/file': typeof AuthOrgSlugProjectIdContentFileIndexRoute
  '/$orgSlug/$projectId/content/text': typeof AuthOrgSlugProjectIdContentTextIndexRoute
  '/$orgSlug/$projectId/marketing-agent/$threadId': typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
  '/$orgSlug/$projectId/search-agent/$threadId': typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/connector-error': typeof ConnectorErrorRoute
  '/login': typeof LoginRoute
  '/org-mismatch': typeof OrgMismatchRoute
  '/payment-inactive': typeof PaymentInactiveRoute
  '/_auth/$orgSlug': typeof AuthOrgSlugRouteRouteWithChildren
  '/user/password-reset': typeof UserPasswordResetRoute
  '/user/resend-verification': typeof UserResendVerificationRoute
  '/user/set-password': typeof UserSetPasswordRoute
  '/user/verify': typeof UserVerifyRoute
  '/user/verify-email': typeof UserVerifyEmailRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/$orgSlug/$projectId': typeof AuthOrgSlugProjectIdRouteRouteWithChildren
  '/_auth/$orgSlug/': typeof AuthOrgSlugIndexRoute
  '/_auth/$orgSlug/$projectId/marketing-agent': typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren
  '/_auth/$orgSlug/$projectId/search-agent': typeof AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren
  '/_auth/$orgSlug/$projectId/': typeof AuthOrgSlugProjectIdIndexRoute
  '/_auth/$orgSlug/account/': typeof AuthOrgSlugAccountIndexRoute
  '/_auth/$orgSlug/profile/': typeof AuthOrgSlugProfileIndexRoute
  '/_auth/$orgSlug/users/': typeof AuthOrgSlugUsersIndexRoute
  '/_auth/$orgSlug/$projectId/content/': typeof AuthOrgSlugProjectIdContentIndexRoute
  '/_auth/$orgSlug/$projectId/marketing-agent/': typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  '/_auth/$orgSlug/$projectId/search-agent/': typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  '/_auth/$orgSlug/content/connector/': typeof AuthOrgSlugContentConnectorIndexRoute
  '/_auth/$orgSlug/content/file/': typeof AuthOrgSlugContentFileIndexRoute
  '/_auth/$orgSlug/content/text/': typeof AuthOrgSlugContentTextIndexRoute
  '/_auth/$orgSlug/$projectId/content/connector/': typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  '/_auth/$orgSlug/$projectId/content/file/': typeof AuthOrgSlugProjectIdContentFileIndexRoute
  '/_auth/$orgSlug/$projectId/content/text/': typeof AuthOrgSlugProjectIdContentTextIndexRoute
  '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/': typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
  '/_auth/$orgSlug/$projectId/search-agent/$threadId/': typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connector-error'
    | '/login'
    | '/org-mismatch'
    | '/payment-inactive'
    | '/$orgSlug'
    | '/user/password-reset'
    | '/user/resend-verification'
    | '/user/set-password'
    | '/user/verify'
    | '/user/verify-email'
    | '/$orgSlug/$projectId'
    | '/$orgSlug/'
    | '/$orgSlug/$projectId/marketing-agent'
    | '/$orgSlug/$projectId/search-agent'
    | '/$orgSlug/$projectId/'
    | '/$orgSlug/account/'
    | '/$orgSlug/profile/'
    | '/$orgSlug/users/'
    | '/$orgSlug/$projectId/content/'
    | '/$orgSlug/$projectId/marketing-agent/'
    | '/$orgSlug/$projectId/search-agent/'
    | '/$orgSlug/content/connector/'
    | '/$orgSlug/content/file/'
    | '/$orgSlug/content/text/'
    | '/$orgSlug/$projectId/content/connector/'
    | '/$orgSlug/$projectId/content/file/'
    | '/$orgSlug/$projectId/content/text/'
    | '/$orgSlug/$projectId/marketing-agent/$threadId/'
    | '/$orgSlug/$projectId/search-agent/$threadId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connector-error'
    | '/login'
    | '/org-mismatch'
    | '/payment-inactive'
    | '/user/password-reset'
    | '/user/resend-verification'
    | '/user/set-password'
    | '/user/verify'
    | '/user/verify-email'
    | '/'
    | '/$orgSlug'
    | '/$orgSlug/$projectId'
    | '/$orgSlug/account'
    | '/$orgSlug/profile'
    | '/$orgSlug/users'
    | '/$orgSlug/$projectId/content'
    | '/$orgSlug/$projectId/marketing-agent'
    | '/$orgSlug/$projectId/search-agent'
    | '/$orgSlug/content/connector'
    | '/$orgSlug/content/file'
    | '/$orgSlug/content/text'
    | '/$orgSlug/$projectId/content/connector'
    | '/$orgSlug/$projectId/content/file'
    | '/$orgSlug/$projectId/content/text'
    | '/$orgSlug/$projectId/marketing-agent/$threadId'
    | '/$orgSlug/$projectId/search-agent/$threadId'
  id:
    | '__root__'
    | '/_auth'
    | '/connector-error'
    | '/login'
    | '/org-mismatch'
    | '/payment-inactive'
    | '/_auth/$orgSlug'
    | '/user/password-reset'
    | '/user/resend-verification'
    | '/user/set-password'
    | '/user/verify'
    | '/user/verify-email'
    | '/_auth/'
    | '/_auth/$orgSlug/$projectId'
    | '/_auth/$orgSlug/'
    | '/_auth/$orgSlug/$projectId/marketing-agent'
    | '/_auth/$orgSlug/$projectId/search-agent'
    | '/_auth/$orgSlug/$projectId/'
    | '/_auth/$orgSlug/account/'
    | '/_auth/$orgSlug/profile/'
    | '/_auth/$orgSlug/users/'
    | '/_auth/$orgSlug/$projectId/content/'
    | '/_auth/$orgSlug/$projectId/marketing-agent/'
    | '/_auth/$orgSlug/$projectId/search-agent/'
    | '/_auth/$orgSlug/content/connector/'
    | '/_auth/$orgSlug/content/file/'
    | '/_auth/$orgSlug/content/text/'
    | '/_auth/$orgSlug/$projectId/content/connector/'
    | '/_auth/$orgSlug/$projectId/content/file/'
    | '/_auth/$orgSlug/$projectId/content/text/'
    | '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/'
    | '/_auth/$orgSlug/$projectId/search-agent/$threadId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ConnectorErrorRoute: typeof ConnectorErrorRoute
  LoginRoute: typeof LoginRoute
  OrgMismatchRoute: typeof OrgMismatchRoute
  PaymentInactiveRoute: typeof PaymentInactiveRoute
  UserPasswordResetRoute: typeof UserPasswordResetRoute
  UserResendVerificationRoute: typeof UserResendVerificationRoute
  UserSetPasswordRoute: typeof UserSetPasswordRoute
  UserVerifyRoute: typeof UserVerifyRoute
  UserVerifyEmailRoute: typeof UserVerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/payment-inactive': {
      id: '/payment-inactive'
      path: '/payment-inactive'
      fullPath: '/payment-inactive'
      preLoaderRoute: typeof PaymentInactiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org-mismatch': {
      id: '/org-mismatch'
      path: '/org-mismatch'
      fullPath: '/org-mismatch'
      preLoaderRoute: typeof OrgMismatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connector-error': {
      id: '/connector-error'
      path: '/connector-error'
      fullPath: '/connector-error'
      preLoaderRoute: typeof ConnectorErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/user/verify-email': {
      id: '/user/verify-email'
      path: '/user/verify-email'
      fullPath: '/user/verify-email'
      preLoaderRoute: typeof UserVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/verify': {
      id: '/user/verify'
      path: '/user/verify'
      fullPath: '/user/verify'
      preLoaderRoute: typeof UserVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/set-password': {
      id: '/user/set-password'
      path: '/user/set-password'
      fullPath: '/user/set-password'
      preLoaderRoute: typeof UserSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/resend-verification': {
      id: '/user/resend-verification'
      path: '/user/resend-verification'
      fullPath: '/user/resend-verification'
      preLoaderRoute: typeof UserResendVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/password-reset': {
      id: '/user/password-reset'
      path: '/user/password-reset'
      fullPath: '/user/password-reset'
      preLoaderRoute: typeof UserPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/$orgSlug': {
      id: '/_auth/$orgSlug'
      path: '/$orgSlug'
      fullPath: '/$orgSlug'
      preLoaderRoute: typeof AuthOrgSlugRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/$orgSlug/': {
      id: '/_auth/$orgSlug/'
      path: '/'
      fullPath: '/$orgSlug/'
      preLoaderRoute: typeof AuthOrgSlugIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/$projectId': {
      id: '/_auth/$orgSlug/$projectId'
      path: '/$projectId'
      fullPath: '/$orgSlug/$projectId'
      preLoaderRoute: typeof AuthOrgSlugProjectIdRouteRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/users/': {
      id: '/_auth/$orgSlug/users/'
      path: '/users'
      fullPath: '/$orgSlug/users/'
      preLoaderRoute: typeof AuthOrgSlugUsersIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/profile/': {
      id: '/_auth/$orgSlug/profile/'
      path: '/profile'
      fullPath: '/$orgSlug/profile/'
      preLoaderRoute: typeof AuthOrgSlugProfileIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/account/': {
      id: '/_auth/$orgSlug/account/'
      path: '/account'
      fullPath: '/$orgSlug/account/'
      preLoaderRoute: typeof AuthOrgSlugAccountIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/$projectId/': {
      id: '/_auth/$orgSlug/$projectId/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/search-agent': {
      id: '/_auth/$orgSlug/$projectId/search-agent'
      path: '/search-agent'
      fullPath: '/$orgSlug/$projectId/search-agent'
      preLoaderRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/marketing-agent': {
      id: '/_auth/$orgSlug/$projectId/marketing-agent'
      path: '/marketing-agent'
      fullPath: '/$orgSlug/$projectId/marketing-agent'
      preLoaderRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/content/text/': {
      id: '/_auth/$orgSlug/content/text/'
      path: '/content/text'
      fullPath: '/$orgSlug/content/text/'
      preLoaderRoute: typeof AuthOrgSlugContentTextIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/content/file/': {
      id: '/_auth/$orgSlug/content/file/'
      path: '/content/file'
      fullPath: '/$orgSlug/content/file/'
      preLoaderRoute: typeof AuthOrgSlugContentFileIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/content/connector/': {
      id: '/_auth/$orgSlug/content/connector/'
      path: '/content/connector'
      fullPath: '/$orgSlug/content/connector/'
      preLoaderRoute: typeof AuthOrgSlugContentConnectorIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/$projectId/search-agent/': {
      id: '/_auth/$orgSlug/$projectId/search-agent/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/search-agent/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdSearchAgentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/marketing-agent/': {
      id: '/_auth/$orgSlug/$projectId/marketing-agent/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/marketing-agent/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdMarketingAgentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/': {
      id: '/_auth/$orgSlug/$projectId/content/'
      path: '/content'
      fullPath: '/$orgSlug/$projectId/content/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/search-agent/$threadId/': {
      id: '/_auth/$orgSlug/$projectId/search-agent/$threadId/'
      path: '/$threadId'
      fullPath: '/$orgSlug/$projectId/search-agent/$threadId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/': {
      id: '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/'
      path: '/$threadId'
      fullPath: '/$orgSlug/$projectId/marketing-agent/$threadId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/text/': {
      id: '/_auth/$orgSlug/$projectId/content/text/'
      path: '/content/text'
      fullPath: '/$orgSlug/$projectId/content/text/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentTextIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/file/': {
      id: '/_auth/$orgSlug/$projectId/content/file/'
      path: '/content/file'
      fullPath: '/$orgSlug/$projectId/content/file/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentFileIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/connector/': {
      id: '/_auth/$orgSlug/$projectId/content/connector/'
      path: '/content/connector'
      fullPath: '/$orgSlug/$projectId/content/connector/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentConnectorIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
  }
}

interface AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren {
  AuthOrgSlugProjectIdMarketingAgentIndexRoute: typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute: typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
}

const AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren: AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren =
  {
    AuthOrgSlugProjectIdMarketingAgentIndexRoute:
      AuthOrgSlugProjectIdMarketingAgentIndexRoute,
    AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute:
      AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute,
  }

const AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren =
  AuthOrgSlugProjectIdMarketingAgentRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren,
  )

interface AuthOrgSlugProjectIdSearchAgentRouteRouteChildren {
  AuthOrgSlugProjectIdSearchAgentIndexRoute: typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute: typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}

const AuthOrgSlugProjectIdSearchAgentRouteRouteChildren: AuthOrgSlugProjectIdSearchAgentRouteRouteChildren =
  {
    AuthOrgSlugProjectIdSearchAgentIndexRoute:
      AuthOrgSlugProjectIdSearchAgentIndexRoute,
    AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute:
      AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute,
  }

const AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren =
  AuthOrgSlugProjectIdSearchAgentRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdSearchAgentRouteRouteChildren,
  )

interface AuthOrgSlugProjectIdRouteRouteChildren {
  AuthOrgSlugProjectIdMarketingAgentRouteRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren
  AuthOrgSlugProjectIdSearchAgentRouteRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren
  AuthOrgSlugProjectIdIndexRoute: typeof AuthOrgSlugProjectIdIndexRoute
  AuthOrgSlugProjectIdContentIndexRoute: typeof AuthOrgSlugProjectIdContentIndexRoute
  AuthOrgSlugProjectIdContentConnectorIndexRoute: typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  AuthOrgSlugProjectIdContentFileIndexRoute: typeof AuthOrgSlugProjectIdContentFileIndexRoute
  AuthOrgSlugProjectIdContentTextIndexRoute: typeof AuthOrgSlugProjectIdContentTextIndexRoute
}

const AuthOrgSlugProjectIdRouteRouteChildren: AuthOrgSlugProjectIdRouteRouteChildren =
  {
    AuthOrgSlugProjectIdMarketingAgentRouteRoute:
      AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren,
    AuthOrgSlugProjectIdSearchAgentRouteRoute:
      AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren,
    AuthOrgSlugProjectIdIndexRoute: AuthOrgSlugProjectIdIndexRoute,
    AuthOrgSlugProjectIdContentIndexRoute:
      AuthOrgSlugProjectIdContentIndexRoute,
    AuthOrgSlugProjectIdContentConnectorIndexRoute:
      AuthOrgSlugProjectIdContentConnectorIndexRoute,
    AuthOrgSlugProjectIdContentFileIndexRoute:
      AuthOrgSlugProjectIdContentFileIndexRoute,
    AuthOrgSlugProjectIdContentTextIndexRoute:
      AuthOrgSlugProjectIdContentTextIndexRoute,
  }

const AuthOrgSlugProjectIdRouteRouteWithChildren =
  AuthOrgSlugProjectIdRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdRouteRouteChildren,
  )

interface AuthOrgSlugRouteRouteChildren {
  AuthOrgSlugProjectIdRouteRoute: typeof AuthOrgSlugProjectIdRouteRouteWithChildren
  AuthOrgSlugIndexRoute: typeof AuthOrgSlugIndexRoute
  AuthOrgSlugAccountIndexRoute: typeof AuthOrgSlugAccountIndexRoute
  AuthOrgSlugProfileIndexRoute: typeof AuthOrgSlugProfileIndexRoute
  AuthOrgSlugUsersIndexRoute: typeof AuthOrgSlugUsersIndexRoute
  AuthOrgSlugContentConnectorIndexRoute: typeof AuthOrgSlugContentConnectorIndexRoute
  AuthOrgSlugContentFileIndexRoute: typeof AuthOrgSlugContentFileIndexRoute
  AuthOrgSlugContentTextIndexRoute: typeof AuthOrgSlugContentTextIndexRoute
}

const AuthOrgSlugRouteRouteChildren: AuthOrgSlugRouteRouteChildren = {
  AuthOrgSlugProjectIdRouteRoute: AuthOrgSlugProjectIdRouteRouteWithChildren,
  AuthOrgSlugIndexRoute: AuthOrgSlugIndexRoute,
  AuthOrgSlugAccountIndexRoute: AuthOrgSlugAccountIndexRoute,
  AuthOrgSlugProfileIndexRoute: AuthOrgSlugProfileIndexRoute,
  AuthOrgSlugUsersIndexRoute: AuthOrgSlugUsersIndexRoute,
  AuthOrgSlugContentConnectorIndexRoute: AuthOrgSlugContentConnectorIndexRoute,
  AuthOrgSlugContentFileIndexRoute: AuthOrgSlugContentFileIndexRoute,
  AuthOrgSlugContentTextIndexRoute: AuthOrgSlugContentTextIndexRoute,
}

const AuthOrgSlugRouteRouteWithChildren =
  AuthOrgSlugRouteRoute._addFileChildren(AuthOrgSlugRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthOrgSlugRouteRoute: typeof AuthOrgSlugRouteRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthOrgSlugRouteRoute: AuthOrgSlugRouteRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ConnectorErrorRoute: ConnectorErrorRoute,
  LoginRoute: LoginRoute,
  OrgMismatchRoute: OrgMismatchRoute,
  PaymentInactiveRoute: PaymentInactiveRoute,
  UserPasswordResetRoute: UserPasswordResetRoute,
  UserResendVerificationRoute: UserResendVerificationRoute,
  UserSetPasswordRoute: UserSetPasswordRoute,
  UserVerifyRoute: UserVerifyRoute,
  UserVerifyEmailRoute: UserVerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
